// extracted by mini-css-extract-plugin
export default {"wrapper":"W1-z","play":"X1-z"};